import React from 'react';
import { useRouter } from 'next/router';
import { useTranslation } from 'react-i18next';
import { SmartTabs, TabSection } from '@platzi/ui';
import { Track } from '@platzi/commons';
import { Steps, Post } from '../';

let tabProgressEventSent = false;
let tabIntroductionEventSent = false;

export const Tabs = () => {
  const { t } = useTranslation();

  const router = useRouter();
  const { slug } = router.query;

  const onClickTab = (tab: string) => {
    if (tabIntroductionEventSent && tab === 'introduction') return;
    if (tabProgressEventSent && tab === 'progress') return;

    Track.send({
      event: `route_tab_click`,
      route_name: slug,
      tab_name: tab,
    });

    if (tab === 'progress') tabProgressEventSent = true;
    if (tab === 'introduction') tabIntroductionEventSent = true;
  };

  return (
    <SmartTabs customClass="Tabs" defaultTab={'progress'} handleClickOnTab={onClickTab}>
      <TabSection key="progress" title={t('route.tabs.routeCourses')} shouldShow>
        <Steps />
      </TabSection>
      <TabSection key="introduction" title={t('route.tabs.about')} shouldShow>
        <Post />
      </TabSection>
    </SmartTabs>
  );
};
